var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBoardingpassTicket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.16675V2.83341M11.5 6.16675V7.8334M11.5 11.1667V12.8334M3.16667 1.16675H14.8333C15.2754 1.16675 15.6993 1.34234 16.0118 1.6549C16.3244 1.96746 16.5 2.39139 16.5 2.83341V5.33341C16.058 5.33341 15.634 5.50901 15.3215 5.82157C15.0089 6.13413 14.8333 6.55805 14.8333 7.0001C14.8333 7.4421 15.0089 7.866 15.3215 8.1786C15.634 8.4912 16.058 8.6667 16.5 8.6667V11.1667C16.5 11.6088 16.3244 12.0327 16.0118 12.3453C15.6993 12.6578 15.2754 12.8334 14.8333 12.8334H3.16667C2.72464 12.8334 2.30072 12.6578 1.98816 12.3453C1.67559 12.0327 1.5 11.6088 1.5 11.1667V8.6667C1.94203 8.6667 2.36595 8.4912 2.67851 8.1786C2.99107 7.866 3.16667 7.4421 3.16667 7.0001C3.16667 6.55805 2.99107 6.13413 2.67851 5.82157C2.36595 5.50901 1.94203 5.33341 1.5 5.33341V2.83341C1.5 2.39139 1.67559 1.96746 1.98816 1.6549C2.30072 1.34234 2.72464 1.16675 3.16667 1.16675Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBoardingpassTicket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/boardingpass-ticket.4fc9d3d9.svg";
export { ForwardRef as ReactComponent };